// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1G3_T","content":"styles_content__UDVN0","checkbox":"styles_checkbox__rb7_z","checkboxLabel":"styles_checkboxLabel__sJAwW"};